/**
 * Professions Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import {store} from "../../store";

// States
const state = {
    professions: [],
    profession: {}
};

// Getters
const getters = {
    professions: state => {
        return state.professions
    },

    profession: state => {
        return state.profession
    }
};

// Actions
const actions = {
    getProfessions(context, payload) {
        function successCallback(response) {
            context.commit('getProfessionsHandler', { professions: response.data.professions });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Profession.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getProfession(context, payload) {
        function successCallback(response) {
            context.commit('getProfessionHandler', { profession: response.data.profession });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Profession.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createProfession(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            router.push({ name: 'profession', params: { profession: response.data.profession.slug } });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Profession.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    updateProfession(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            store.dispatch('findAndRemove', {name: 'profession' });

            router.push({ name: 'profession', params: { profession: response.data.profession.slug } });

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Profession.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deleteProfession(context, payload) {
        function successCallback(response) {
            context.commit('deleteProfessionHandler', { index: payload.index, successMessage: payload.successMessage });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Profession.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },
};

// Mutations
const mutations = {
    getProfessionsHandler(state, { professions }) {
        // Update professions state
        state.professions = professions;
    },

    getProfessionHandler(state, { profession }) {
        // Update profession state
        state.profession = profession;
    },

    deleteProfessionHandler(state, { index, successMessage }) {
        let i = state.professions.findIndex(profession => profession.slug === index);

        if (~i) {
            state.professions.splice(i, 1);

            router.push({ name: 'professions' });

            Vue.swal(
                successMessage,
                '',
                'success'
            );
        }
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}